import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, NavLink } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import { useHistory } from "react-router-dom";
import { URL_SEARCH, URL_USER, URL_LOGIN, URL_HOME } from "@components/Routes/Location";
import { User } from "@user/Context/User";
import { user, home } from "@core";
import { BarraBusquedaPC } from "@app/Pages/Menu/components/barraSuperior/components/BarraBusquedaPC";
import { BarraBusquedaMobile } from "@app/Pages/Menu/components/barraSuperior/components/BarraBusquedaMobile";
import iconTrophy from "@app/Resources/Images/Icon-trophy.svg";

import "./BarraSuperior.css";
import { PointsAnimation } from "./components/PointsAnimation";

import MenuLiveComponent from "./components/MenuLiveComponent";
import { SWITCHER_WIDTH } from "../../../../Utils/Constants";
import useOutput from "../../../../Utils/Hooks/useOutput";
import { toArray } from "../../../../Components/Kotlin/KotlinUtils";
import { compareUserProfileObjects } from "../../../../Utils/utils";
import { MENU_SCREEN_ID_HOME } from "../../MenuConstants";
import "bootstrap/dist/css/bootstrap.css";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { LanguagesComponent } from "./components/LanguagesComponent";
import { MULTITENANT_CONSTANTS, TENANT } from "../../../../Resources/Multitenant/tenantConstants";
import { STATE_CONTENT_RESET } from "../../../../../../home/src/Pages/Home/HomeComponentConstants";
import { useSelector } from "react-redux";

export function BarraSuperiorSimple() {
  return <BarraSuperior clase="BarraSuperiorSimple" />;
}

export const BarraSuperior = (props) => {
  const { clase, sections, homeParentController, handleChangeSection, userAppController } = props;
  const history = useHistory();
  const buttonUser = sections.filter((section) => section.url === URL_USER)[0];
  const buttonSearch = sections.filter((section) => section.url === URL_SEARCH)[0];

  const outputFn = useOutput();
  const { keycloak, initialized } = useKeycloak();
  const { t } = useTranslation();
  const { rol } = useContext(User);

  const homeSection = useSelector((state) => state.commonState.homeSection);

  const [renderMobileVersion, setRenderMobileVersion] = useState(window.innerWidth <= SWITCHER_WIDTH);
  const [controller, setController] = useState(null);
  const [availableLanguages, setAvailableLanguages] = useState(null);

  const [homeController, setHomeController] = useState(null);

  useEffect(() => {
    let homeCon = homeParentController ? homeParentController : new home.controller();
    let homeBinding = homeCon.bind(homeModel, (o) => outputFn(o, homeOutput, home));
    setHomeController(homeCon);
    return () => homeCon.unbind(homeBinding);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const homeModel = () => {};

  const homeOutput = () => {};

  useEffect(() => {
    const con = userAppController;
    let binding = con.bind(model, (o) => outputFn(o, output, user));
    con.dispatch(user.events.LogUserProfileView);
    setController(con);

    return () => {
      con.unbind(binding);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const model = (o) => {
    const formattedModel = {};
    formattedModel.loading = o.loadingUser.name$;
    if (formattedModel.loading === STATE_CONTENT_RESET) {
      if (keycloak?.authenticated) {
        if (window.location.pathname === URL_HOME) {
          handleGoToLogin();
        } else history.push(window.location.pathname);
      }
    } else {
      if (o.availableLanguages) {
        formattedModel.availableLanguages = toArray(o.availableLanguages);
      }
      if (compareUserProfileObjects(setAvailableLanguages, formattedModel)) {
        setAvailableLanguages(formattedModel.availableLanguages);
      }
    }
  };
  const output = () => {};

  const handleGoToHome = () => {
    const ev = new home.events.LoadScreen(MENU_SCREEN_ID_HOME);
    homeController.dispatch(ev);
    handleChangeSection(homeSection);

    if (window.location.pathname !== URL_HOME) {
      history.push(URL_HOME);
    }
  };

  const handleGoToLogin = () => {
    history.push(URL_LOGIN);
  };

  const handleResize = () => {
    setRenderMobileVersion(window.innerWidth <= SWITCHER_WIDTH);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.innerWidth]);

  const isLogin = () => {
    return initialized && keycloak.authenticated;
  };

  return (
    <div className={"BarraSuperior " + (!!clase && clase)}>
      <div onClick={handleGoToHome} className={"LogoContainer"}>
        <div className="Logo-Barra" />
      </div>
      <div className={"groupOptions"}>
        {buttonSearch && (
          <div className="SearchBarWrapper">
            {renderMobileVersion ? (
              <div className="SearchBarContainer">
                <BarraBusquedaMobile buttonSearch={buttonSearch} />
              </div>
            ) : (
              <div>
                <BarraBusquedaPC buttonSearch={buttonSearch} />
              </div>
            )}
          </div>
        )}

        {buttonUser && keycloak?.authenticated && (
          <div className="Usuario">
            <div className={"UserSeccion"}>
              <User.Consumer>
                {(User) =>
                  User && (
                    <Link to={URL_USER}>
                      <img className="AvatarMenu" src={User.avatar?.url} alt="Usuario" />
                      {MULTITENANT_CONSTANTS[TENANT].gamification && User?.points && (
                        <div className="RankingMenu">
                          <img className="TrophyMenu" src={iconTrophy} alt="IconTropy" />
                          <PointsAnimation userPoints={User.points} />
                        </div>
                      )}
                    </Link>
                  )
                }
              </User.Consumer>
            </div>
          </div>
        )}

        {buttonUser &&
          !keycloak?.authenticated &&
          (!renderMobileVersion || (renderMobileVersion && MULTITENANT_CONSTANTS[TENANT]?.showLoginButtonInMobile)) && (
            <div className="Usuario">
              {renderMobileVersion ? (
                <div onClick={handleGoToLogin} className={"LoginButton"}>
                  <ion-icon name="log-in-outline" />
                </div>
              ) : (
                <NavLink to={URL_LOGIN} className={"LoginButton"}>
                  {t("user.login")}
                </NavLink>
              )}
            </div>
          )}

        {isLogin() && <LanguagesComponent controller={controller} availableLanguages={availableLanguages} />}

        <OverlayTrigger
          delay={{ hide: 450, show: 300 }}
          placement="bottom"
          overlay={(props) => <Tooltip {...props}>{t("subtitle.LIVE")}</Tooltip>}
        >
          <div>
            <MenuLiveComponent
              userAge={rol?.maxAge}
              rol={rol}
              theme={keycloak.clientId}
              sections={sections}
              homeController={homeController}
              handleChangeSection={handleChangeSection}
            />
          </div>
        </OverlayTrigger>
      </div>
    </div>
  );
};
